
let process = new Worker('/js/worker/process.js');

var echo = {

  listeners: {},

  listen: function(queuer, id) {


    echo.listeners[id] = setInterval(function(){

      $.ajax({
        url: `/stream/${id}`,
        type: 'GET',
        headers: {
          Accept: 'application/json'
        },
      })
      .done(function(response) {

        queue.updateStatus(queuer, response);

      });
      

    }, 1500);

  },

  leave: function(id) {
    clearInterval(echo.listeners[id]);
  }
}

var queue = {

  on: {},

  presence: {},

  keepStart: function(queuer, token) {
    process.postMessage({
      command: 'start',
      id: queuer.attr('id'),
      timeout: 30000,
      action: `/${$('html').attr('lang')}/process`,
      csrf: document.querySelector('meta[name="csrf-token"]').content,
      form: {
        token: token
      },
    });
  },

  keepStop: function(queuer) {

    process.postMessage({
      command: 'stop',
      id: queuer.attr('id')
    });
  },

  updateStatus: function(queuer, status) {

    var $bar     = queuer.find('.queue-status-bar div div');
    var $msg     = queuer.find('.queue-status-message');
    var $count   = queuer.find('.queue-status-count');
    var $percent = queuer.find('.queue-status-percent');

    $msg.text(status.message);

    if(status.current != undefined) {
      var count = status.current.toString().padStart(status.max.toString().length, 0) + '/' + status.max;

      $count.text(status.max && status.max != status.current ? count : '');

      var percent = Math.floor((status.current/status.max)*100);
      $percent.text((status.max ? percent : 0) + '%' );

      if(status.max)
        $bar.removeClass('indeterminate').addClass('determinate').css('width', percent + '%');

      if(status.status == 'finished') {
        echo.leave(queuer.data('queue-id'));
        if(queue.on.finish && queue.on.finish.delegate == '#' + queuer.attr('id')) queue.on.finish.handler($(queue.on.finish.delegate), status);
        queuer.data('queue-id', null);
        queue.keepStop(queuer);

      }
      else if(status.status == 'failed') {
        echo.leave(queuer.data('queue-id'));
        queuer.data('queue-id', null);
        if(queue.on.fail && queue.on.fail.delegate == '#' + queuer.attr('id')) queue.on.fail.handler($(queue.on.fail.delegate));
        $bar.css('width', '100%').removeClass('indeterminate').addClass('determinate').parent().removeClass('progress-primary').addClass('progress-danger');
        queue.keepStop(queuer);

      }
      
    }
  },

  dispatch: function(queuer) {

    var data = {};

    var inputs = $(`.queue-input[data-queue="#${queuer.attr('id')}"]`).addClass('d-none');

    for (var i = 0; i < inputs.length; i++) {
      var input = $(inputs[i]);

      var value;

      if(input.attr('type') == 'checkbox'){
        value = input.is(':checked') ? 'true' : null;
      }
      else {
        value = input.val();
      }

      if(value) {
        data[input.attr('name')] = value;
      }

    }

    $.ajax({
      url: queuer.attr('data-url'),
      type: 'post',
      data: data,
      headers: {
        Accept: 'application/json'
      }
    })
    .done(function(status) {

      if(!status.stream_token || !status.process_token) {
        queuer.data('queue-id', null);
        if(queue.on.fail && queue.on.fail.delegate == '#' + queuer.attr('id')) queue.on.fail.handler($(queue.on.fail.delegate));
        queuer.find('.queue-status-bar div div').css('width', '100%').removeClass('indeterminate').addClass('determinate').parent().removeClass('progress-primary').addClass('progress-danger');
        return;
      }

      queuer.find('.queue-status-message').text(queuer.data('waiting'));

      queuer.data('queue-id', status.stream_token);
      

      echo.listen(queuer, status.stream_token);

      queue.keepStart(queuer, status.process_token);

    });
    
  },

  kill: function(queuer) {

    var id = queuer.data('queue-id');

    if(id) echo.leave(status.stream_token);

    queuer.find('.queue-status-bar div div').addClass('indeterminate').removeClass('determinate').removeAttr('style');
    queuer.find('.queue-status-bar div').removeClass('progress-danger').addClass('progress-primary').removeClass('determinate').removeAttr('style');
    queuer.find('.queue-status-message').text(queuer.data('indeterminate'));
    queuer.find('.queue-status-count').text('');
    queuer.find('.queue-status-percent').text('');


    var stop    = $(`[data-queue="stop"][data-target="#${queuer.attr('id')}"]`)
    var start   = $(`[data-queue="start"][data-target="#${queuer.attr('id')}"]`)
    queuer.addClass('d-none');
    start.removeClass('disabled');
    stop.removeClass('disabled').blur();

    if(queue.on.kill && queue.on.kill.delegate == '#' + queuer.attr('id')) queue.on.kill.handler($(queue.on.kill.delegate));

    queue.keepStop(queuer);

    echo.leave(queuer.data('queue-id'));

    if(queuer.data('queue-id')) {

      $.ajax({
        url: queuer.data('url'),
        type: 'post',
        data: {abort: true},
        headers: {
          Accept: 'application/json'
        }
      });

    }


    $(`.queue-input[data-queue="#${queuer.attr('id')}"]`).removeClass('d-none');

  },

  rebind: function() {


    $('.queue').addClass('d-none');

    $('[data-queue="start"]').click(function(event) {


      var target  = $(this).data('target');
      var queuer  = $(target);
      var stop    = $(`[data-queue="stop"][data-target="${target}"]`)
      var start   = $(this);

      queuer.find('.queue-status-bar div').removeClass('progress-danger determinate').addClass('progress-primary indeterminate').removeAttr('style');

      queuer.removeClass('d-none');
      start.addClass('disabled').blur();
      stop.removeClass('disabled');

      if(queue.on.start && queue.on.start.delegate == '#' + queuer.attr('id')) queue.on.start.handler($(queue.on.start.delegate));

      queue.dispatch(queuer);

    });

    $('[data-queue="stop"]').click(function(event) {

      var target  = $(this).data('target');
      var queuer  = $(target);

      queue.kill(queuer);

    });

  },


  init: function() {

    queue.rebind();

    window.onbeforeunload = function() {

      $('[data-queue="start"]').each(function(index, el) {
        var queuer = $($(el).data('target'));
        var id = queuer.data('queue-id');
        if(!id) return;
        $.ajax({
          url: queuer.data('url'),
          type: 'post',
          data: {abort: true},
          headers: {
            Accept: 'application/json'
          }
        });
      });
    }

  }

}

queue.init();

module.exports = {

  kill: function(queuer) {
    queue.kill(queuer);
  },

  on: function(event, delegate, handler) {
    queue.on[event]  = {delegate: delegate, handler: handler};
  },

  rebind: function() {
    queue.rebind();
  }
}